<template>
  <transition name="component-fade" v-if="showOverlayBG">
    <div class="overlay-bg"></div>
  </transition>
</template>

<script>
export default {
  computed: {
    showOverlayBG() {
      return this.$store.getters.getOverlayBGState;
    }
  }
};
</script>
